export const truncateUrl = (url: string, maxLength: number = 50): string => {
    if (url.length <= maxLength) return url;

    const start = url.substring(0, Math.floor(maxLength / 2) - 1);
    const end = url.substring(url.length - Math.floor(maxLength / 2) + 2);

    return `${start}...${end}`;
};
